import { get } from 'modules/api';

export const fetchCountries = () => get('countries/');
